exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Dancing+Script);", ""]);

// module
exports.push([module.id, "body {\n  height: 100%;\n}\n\nh1 {\n  color: blueviolet;\n  margin: 0 auto;\n  font-size: 5em;\n  text-align: center;\n  padding-top: 15vh;\n  font-family: 'Dancing Script', cursive;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/index.css
// module id = 1637
// module chunks = 0